import {TrackingBasket} from '../../../types';
import {TrackWishlistPageView} from '../../../types/tracking-wishlist';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {ShouldPushToDataLayerObject} from '../helpers/datalayer';

export interface PageViewEvent {
  event: 'view_basket' | 'view_wishlist';
  basket?: TrackingBasket;
  wishlist?: TrackWishlistPageView;
}

export const trackPageViewWithProducts =
  (props: {basket: TrackingBasket} | {wishlist: TrackWishlistPageView}) =>
  (_: TrackingClientStateHolder): ShouldPushToDataLayerObject => {
    const event: PageViewEvent = {
      event: 'basket' in props ? 'view_basket' : 'view_wishlist',
      ...props,
    };

    return {
      GA4: event,
    };
  };
